import { AspectRatio } from '@chakra-ui/react';
import Image from 'next/image';
import { FC } from 'react';

interface ILectureCardImageProps {
  src?: string;
  alt?: string;
}

export const LectureCardImage: FC<ILectureCardImageProps> = ({ src, alt }) => (
  <AspectRatio maxW="full" ratio={1.69}>
    <Image src={src} alt={alt} fill sizes="300px" />
  </AspectRatio>
);
